import type { DocumentRef } from '../../lib/documentReader'
import type { DrawerTarget } from '../objectDrawerTypes'
import { contextWorkView, type ContextRequirement } from '../workbench/contextWork'
import {
  isBookDiscoveryCard,
  recordHref,
  subchainScope,
  workbenchHref,
  type RecordContext,
  type ViewScope,
} from './context'

export interface RecordEvidenceCard {
  id: string
  label: string
  requirements: readonly ContextRequirement[]
  documents: readonly DocumentRef[]
  recordHref: string
  chaseHref: string
}
export interface RecordEvidenceContext {
  cards: readonly RecordEvidenceCard[]
  available: boolean
  onChanged: () => void
}

/** Only existing current cards supply exact target/requirement membership. */
export function recordEvidenceFacts(
  value: RecordContext,
  scope: ViewScope,
  target: DrawerTarget,
  selectedCardId?: string
): readonly RecordEvidenceCard[] {
  if (!scope.fund_id || !value.fund_ids.includes(scope.fund_id)) return []
  const result: RecordEvidenceCard[] = []
  for (const item of contextWorkView(value.work).cards) {
    if (
      isBookDiscoveryCard(item.card) ||
      !item.card.fund_ids.includes(scope.fund_id) ||
      (selectedCardId && item.card.id !== selectedCardId) ||
      !item.card.members.some((member) => member.kind === target.type && member.id === target.id)
    )
      continue
    const requirements = item.requirements.filter(
      (row) => row.target.kind === target.type && row.target.id === target.id
    )
    if (!requirements.length) continue
    const selectedScope = subchainScope(item.card, scope)
    result.push({
      id: item.card.id,
      label: item.card.label,
      requirements,
      documents: item.documents,
      recordHref: recordHref(selectedScope, { focus: `${target.type}:${target.id}` }),
      chaseHref: workbenchHref(selectedScope, 'chase', item.card.id),
    })
  }
  return result
}
